import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

import * as yup from 'yup';

/** Car category response body */
export interface CarCategoryFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The camera will be permanently deleted six months after this date. */
  deleted?: Date;
  /** Category name */
  name: string;
  /** Tariff (amount per hour) */
  tariff: number;
  /** The user who created this car category */
  createdBy?: UserFindInterface;
  /** Default car category */
  isDefault: boolean;
}

/** Car category response body - DTO schema */
export const CarCategoryFindDto = SerdeDtoClass.create<CarCategoryFindInterface>(CctvDtoKeysEnum.CAR_CATEGORY_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создана',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменена',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удалена',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название категории ТС',
    serializer: yup.string(),
  },
  tariff: {
    sortable: true,
    label: 'Тариф (сумма в час)',
    serializer: yup.number(),
  },
  createdBy: {
    optional: true,
    sortable: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  isDefault: {
    label: 'По умолчанию',
    serializer: yup.boolean(),
  },
});
